import { HandIcon } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/core/tooltip';

type BillHoldIndicatorProps = {
  count: number;
};

/**
 * Leading icon shown against a bill that has one or more holds. A held bill
 * cannot be closed, so the indicator doubles as the visual cue for why the
 * Close action is unavailable. Renders nothing when the bill has no holds.
 *
 * The hold count is announced to assistive tech via the trigger's aria-label
 * and surfaced visually in the tooltip.
 */
export function BillHoldIndicator({ count }: BillHoldIndicatorProps) {
  if (count <= 0) return null;

  const label = `${count} hold${count === 1 ? '' : 's'}`;

  return (
    <Tooltip>
      <TooltipTrigger aria-label={label} className="inline-flex">
        <HandIcon className="size-4 text-destructive" aria-hidden />
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
